import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

import { css } from '@emotion/react';

import Button from '@components/Common/Button';

interface Props {
  isInLayout?: boolean;
}

/** 메인 컴포넌트: 404페이지 */
const PageNotFound: FunctionComponent<Props> = ({ isInLayout = false }) => {
  const navigate = useNavigate();

  return (
    <>
      <div css={container(isInLayout)}>
        <img src="/assets/images/page_not_found.png" alt="page_not_found" />
        <div className="title">원하시는 페이지를 찾을 수 없습니다.</div>
        <div className="subTitle">
          찾으려는 페이지의 주소가 잘못 입력되었거나,
          <br />
          주소의 변경 혹은 삭제로 인해 사용하실 수 없습니다.
          <br />
          입력하신 페이지의 주소가 정확한지 다시 한번 확인해 주세요.
        </div>
        <Button
          theme="secondary"
          label={isInLayout ? '메인으로' : 'GMS 메인으로'}
          height={42}
          fontSize={16}
          handleClick={() => navigate('/')}
        />
      </div>
    </>
  );
};

export default PageNotFound;

const container = (isInLayout: boolean) => css`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  width: ${isInLayout ? '100%' : '100vw'};
  height: ${isInLayout ? '100%' : '100vh'};
  align-items: center;
  justify-content: center;
  img {
    height: 400px;
  }
  .title {
    font-size: 24px;
    font-weight: 700;
    color: #e70082;
  }
  .subTitle {
    font-size: 16px;
    line-height: 30px;
    color: #3f3d56;
    text-align: center;
    margin-bottom: 20px;
  }
`;
